module.exports = "/_next/static/images/img__notice_successRegister-572232b4b7d385a1c34e889159b8eade.png";